export const classReducer = (state = { loading: false, dashboard: null, dashboardError: null, error: null, groups: [], sessions: [], currentSession: null, sessionDetail: null, sessionStudents: [], groupStudents: [], groupStudentsError: null, availableTeachers: [], teacherGroups: [] }, action) => {
    switch (action.type) {
        case 'DASHBOARD_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'DASHBOARD_SUCCESS':
            return {
                ...state,
                loading: false,
                dashboard: action.payload,
                dashboardError: null
            }
        case 'DASHBOARD_ERROR':
            return {
                ...state,
                loading: false,
                dashboard: null,
                dashboardError: action.payload
            }
        case 'GROUPS_SUCCESS':
            return {
                ...state,
                loading: false,
                groups: action.payload
            }
        case 'SESSIONS_SUCCESS':
            return {
                ...state,
                loading: false,
                sessions: action.payload
            }
        case 'SESSION_SUCCESS':
            return {
                ...state,
                loading: false,
                currentSession: action.payload
            }
        case 'SESSION_DETAIL_SUCCESS':
            return {
                ...state,
                loading: false,
                sessionDetail: action.payload.session,
                sessionStudents: action.payload.students
            }
        case 'SESSION_DETAIL_CLEAR':
            return {
                ...state,
                sessionDetail: null,
                sessionStudents: [],
                loading: true
            }
        case 'SESSION_UPDATE': {
            const doc = action.payload || {}
            const prevDetail = state.sessionDetail || {}
            const prevLocal = prevDetail.localSession || {}
            return {
                ...state,
                currentSession: { ...state.currentSession, ...doc },
                sessionDetail: {
                    ...prevDetail,
                    localSession: { ...prevLocal, ...doc }
                }
            }
        }
        case 'GROUP_STUDENTS_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'GROUP_STUDENTS_SUCCESS':
            return {
                ...state,
                loading: false,
                groupStudents: action.payload,
                groupStudentsError: null
            }
        case 'GROUP_STUDENTS_ERROR':
            return {
                ...state,
                loading: false,
                groupStudentsError: action.payload
            }
        case 'GROUPS_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case 'AVAILABLE_TEACHERS_SUCCESS':
            return {
                ...state,
                availableTeachers: action.payload
            }
        case 'TEACHER_GROUPS_SUCCESS':
            return {
                ...state,
                loading: false,
                teacherGroups: action.payload
            }
        case 'GROUP_SUBSTITUTE_UPDATE':
            return {
                ...state,
                teacherGroups: state.teacherGroups.map(g =>
                    g.odooGroupId === action.payload.groupId
                        ? { ...g, substitute: action.payload.substitute }
                        : g
                )
            }
        default:
            return state
    }
}
